import { TbClock, TbFileText, TbSend } from "solid-icons/tb";
import { For } from "solid-js";
import { Dynamic } from "solid-js/web";
import { useI18n } from "~/i18n";
import type { TranslationKey } from "~/i18n/translations";

const POINTS: { icon: typeof TbClock; title: TranslationKey; body: TranslationKey }[] = [
  { icon: TbFileText, title: "marketing.home.execs.prep_title", body: "marketing.home.execs.prep_body" },
  { icon: TbSend, title: "marketing.home.execs.followup_title", body: "marketing.home.execs.followup_body" },
  { icon: TbClock, title: "marketing.home.execs.recurring_title", body: "marketing.home.execs.recurring_body" },
];

/** Prep, follow-ups and recurring Actions as a short list beside the follow-through tab's headline. */
export const FollowThroughPoints = () => {
  const { t } = useI18n();
  return (
    <ul class="flex flex-col gap-3">
      <For each={POINTS}>
        {(point) => (
          <li class="flex items-start gap-3">
            <span class="mk-ink grid size-7 shrink-0 place-items-center rounded-lg bg-(--c)/12 ring-1 ring-(--c)/20 dark:bg-(--c)/20">
              <Dynamic component={point.icon} class="size-4" aria-hidden="true" />
            </span>
            <span class="text-sm leading-relaxed">
              <span class="font-semibold">{t(point.title)}.</span>{" "}
              <span class="text-secondary-text">{t(point.body)}</span>
            </span>
          </li>
        )}
      </For>
    </ul>
  );
};
